var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',{staticClass:"inner",domProps:{"innerHTML":_vm._s(_vm.compiledMarkdown)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }